import Link from 'next/link';
import styles from './index.module.scss';

type Props = {
  href: URL | {};
  as?: string;
  text: string;
  onClick?: () => void;
};
export const ReadMoreButton: React.FC<Props> = ({ href, as, text, onClick }) => {
  return (
    <Link as={as} href={href}>
      <a onClick={onClick} className={styles.container}>
        <div className={styles.text}>{text}</div>
        <div className={styles.arrow} />
      </a>
    </Link>
  );
};
